// assets.js
export const mapMarkers = [{
	type: 'toilet',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/toilet.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			"id": 101,
			"longitude": 112.17736365821602,
			"latitude": 31.006366885071804,
			"name": "厕所"
		},
		{
			"id": 102,
			"longitude": 112.17723065821603,
			"latitude": 31.004781885071804,
			"name": "厕所"
		},
		{
			"id": 103,
			"longitude": 112.17628965821602,
			"latitude": 31.008375885071804,
			"name": "厕所"
		},
		{
			"id": 104,
			"longitude": 112.17599265821603,
			"latitude": 31.005498885071804,
			"name": "厕所"
		},
		{
			"id": 105,
			"longitude": 112.17735565821603,
			"latitude": 31.009948885071804,
			"name": "厕所"
		},
		{
			"id": 106,
			"longitude": 112.17316065821602,
			"latitude": 31.010186885071804,
			"name": "厕所"
		},
		{
			"id": 107,
			"longitude": 112.17882665821603,
			"latitude": 31.012183885071803,
			"name": "厕所"
		},
		{
			"id": 108,
			"longitude": 112.17781965821602,
			"latitude": 31.012598885071804,
			"name": "厕所"
		},
		{
			"id": 109,
			"longitude": 112.17732265821603,
			"latitude": 31.013144885071803,
			"name": "厕所"
		},
		{
			"id": 110,
			"longitude": 112.17305265821603,
			"latitude": 31.013842885071803,
			"name": "厕所"
		},
		{
			"id": 111,
			"longitude": 112.17328865821602,
			"latitude": 31.015728885071803,
			"name": "厕所"
		},
		{
			"id": 112,
			"longitude": 112.17563565821603,
			"latitude": 31.014156885071803,
			"name": "厕所"
		},
		{
			"id": 113,
			"longitude": 112.17805765821603,
			"latitude": 31.015974885071804,
			"name": "厕所"
		},
		{
			"id": 114,
			"longitude": 112.17805765821603,
			"latitude": 31.015974885071804,
			"name": "厕所"
		},
		{
			"id": 115,
			"longitude": 112.17872265821603,
			"latitude": 31.014202885071804,
			"name": "厕所"
		},
		{
			"id": 116,
			"longitude": 112.17481665821602,
			"latitude": 31.018830885071804,
			"name": "厕所"
		},
		{
			"id": 117,
			"longitude": 112.17468665821602,
			"latitude": 31.016567885071803,
			"name": "厕所"
		},
		{
			"id": 118,
			"longitude": 112.17502965821602,
			"latitude": 31.016676885071804,
			"name": "厕所"
		},
		{
			"id": 119,
			"longitude": 112.17333865821602,
			"latitude": 31.017477885071804,
			"name": "厕所"
		},
		{
			"id": 120,
			"longitude": 112.18059365821602,
			"latitude": 31.005414885071804,
			"name": "厕所"
		}
	]
}, {
	type: 'parking',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/parking.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			id: 201,
			longitude: 112.18232749099889,
			latitude: 31.012513918042853,
			name: '东1停车场'
		},
		{
			id: 202,
			longitude: 112.17975609546716,
			latitude: 31.009976807156193,
			name: '东2停车场'
		},
		{
			id: 203,
			longitude: 112.17287823747893,
			latitude: 31.01241671437313,
			name: '西1停车场'
		}, {
			id: 204,
			longitude: 112.18190850514031,
			latitude: 31.005199383798733,
			name: '南1停车场'
		}
	]
}, {
	type: 'food',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/food.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			id: 301,
			name: "东门超市",
			longitude: 112.1801547584937,
			latitude: 31.011605186739846
		},
		{
			id: 302,
			name: "鑫鑫超市",
			longitude: 112.18074356535499,
			latitude: 31.010563079192824
		},
		{
			id: 303,
			name: "楚松园",
			longitude: 112.1808180133773,
			latitude: 31.010242490807467
		},
		{
			id: 304,
			name: "田阿姨私房菜",
			longitude: 112.18058743397182,
			latitude: 31.010612988452614
		},
		{
			id: 305,
			name: "甜甜烘焙",
			longitude: 112.18053685069742,
			latitude: 31.01070833867567
		},
		{
			id: 306,
			name: "潇湘食尊",
			longitude: 112.17967399240956,
			latitude: 31.011861599580595
		},
		{
			id: 307,
			name: "荆品名门",
			longitude: 112.18036589346116,
			latitude: 31.01056564816435
		},
		{
			id: 308,
			name: "休闲餐吧",
			longitude: 112.17297894217415,
			latitude: 31.0137091014006
		},
		{
			id: 309,
			name: "小虎堂",
			longitude: 112.17340514535522,
			latitude: 31.014316439240833
		},
		{
			id: 310,
			name: "餐饮",
			longitude: 112.1734051453552,
			latitude: 31.017344974318537
		},
		{
			id: 311,
			name: "荆派乐园",
			longitude: 112.17614510312933,
			latitude: 31.015852664493558
		},
		{
			id: 312,
			name: "气球、非遗",
			longitude: 112.17436858040946,
			latitude: 31.01334035329149
		},
		{
			id: 313,
			name: "文创商品",
			longitude: 112.17998197067959,
			latitude: 31.006950530653036
		},
		{
			id: 314,
			name: "棉花糖",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 315,
			name: "特产便利店",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 316,
			name: "网红大可乐",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 317,
			name: "百特茶",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 318,
			name: "文创雪糕",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 319,
			name: "淄博烧烤",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 320,
			name: "长沙臭豆腐",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 321,
			name: "炒酸奶",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 322,
			name: "9.9元小串",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 323,
			name: "盼哥豆花",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 324,
			name: "襄阳牛肉面",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 325,
			name: "桥头排骨",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 326,
			name: "关东煮",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 327,
			name: "8090怀旧零食铺",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 328,
			name: "公安锅盔",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		},
		{
			id: 329,
			name: "邓氏阿嬷手作",
			longitude: 112.17385810292387,
			latitude: 31.01691556710961
		}
	]
}, {
	type: 'scenic',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/scenic.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			"id": 401,
			"latitude": 31.009873885071803,
			"longitude": 112.17776665821602,
			"name": "百合驿"
		},
		{
			"id": 402,
			"latitude": 31.010993885071803,
			"longitude": 112.17873365821602,
			"name": "芸薹驿"
		},
		{
			"id": 403,
			"latitude": 31.014202885071804,
			"longitude": 112.17872265821603,
			"name": "石榴驿"
		},
		{
			"id": 404,
			"latitude": 31.015974885071804,
			"longitude": 112.17805565821603,
			"name": "杜鹃驿"
		},
		{
			"id": 405,
			"latitude": 31.014656885071804,
			"longitude": 112.17801265821603,
			"name": "玫瑰驿"
		},
		{
			"id": 406,
			"latitude": 31.018348885071803,
			"longitude": 112.17504065821602,
			"name": "桂花驿"
		},
		{
			"id": 407,
			"latitude": 31.017483885071803,
			"longitude": 112.17332865821603,
			"name": "桃花驿"
		},
		{
			"id": 408,
			"latitude": 31.016367885071804,
			"longitude": 112.17309765821603,
			"name": "荷花驿"
		},
		{
			"id": 409,
			"latitude": 31.014437885071804,
			"longitude": 112.17327865821603,
			"name": "紫薇驿"
		},
		{
			"id": 410,
			"latitude": 31.012608885071803,
			"longitude": 112.17666165821603,
			"name": "梅花驿"
		},
		{
			"id": 411,
			"latitude": 31.010240885071804,
			"longitude": 112.17328765821603,
			"name": "兰花驿"
		},
		{
			"id": 412,
			"latitude": 31.010416885071804,
			"longitude": 112.17665965821603,
			"name": "菊花驿"
		},
		{
			"id": 413,
			"latitude": 31.012218885071804,
			"longitude": 112.17970165821603,
			"name": "虎座凤鸟鼓架"
		},
		{
			"id": 414,
			"latitude": 31.015227885071804,
			"longitude": 112.17592065821603,
			"name": "自然博物馆"
		},
		{
			"id": 415,
			"latitude": 31.015382885071804,
			"longitude": 112.17497165821603,
			"name": "时光市集"
		},
		{
			"id": 416,
			"latitude": 31.013141885071804,
			"longitude": 112.17328465821603,
			"name": "荆梦乐园"
		},
		{
			"id": 417,
			"latitude": 31.012734885071803,
			"longitude": 112.17811965821603,
			"name": "森林之旅"
		},
		{
			"id": 418,
			"latitude": 31.012239885071803,
			"longitude": 112.17764765821603,
			"name": "玻璃滑道"
		},
		{
			"id": 419,
			"latitude": 31.012202885071804,
			"longitude": 112.17690465821603,
			"name": "九曲花谷"
		},
		{
			"id": 420,
			"latitude": 31.013101885071804,
			"longitude": 112.17730565821603,
			"name": "先农阁"
		},
		{
			"id": 421,
			"latitude": 31.014905885071804,
			"longitude": 112.17620065821603,
			"name": "遇见荆楚"
		},
		{
			"id": 422,
			"latitude": 31.006583885071804,
			"longitude": 112.17604965821603,
			"name": "南苑"
		},
		{
			"id": 423,
			"latitude": 31.011584885071803,
			"longitude": 112.17520365821603,
			"name": "荆门园"
		},
		{
			"id": 424,
			"latitude": 31.014013885071803,
			"longitude": 112.17274965821603,
			"name": "黄冈园"
		},
		{
			"id": 425,
			"latitude": 31.013810885071804,
			"longitude": 112.17330165821603,
			"name": "襄阳园"
		},
		{
			"id": 426,
			"latitude": 31.013497885071804,
			"longitude": 112.17430565821602,
			"name": "宜昌园"
		},
		{
			"id": 427,
			"latitude": 31.012912885071803,
			"longitude": 112.17462965821603,
			"name": "荆州园"
		},
		{
			"id": 428,
			"latitude": 31.011619885071804,
			"longitude": 112.17377065821603,
			"name": "武汉园"
		},
		{
			"id": 429,
			"latitude": 31.009880885071803,
			"longitude": 112.17337465821603,
			"name": "随州园"
		},
		{
			"id": 430,
			"latitude": 31.010694885071804,
			"longitude": 112.17449965821603,
			"name": "神农架园"
		},
		{
			"id": 431,
			"latitude": 31.013901885071804,
			"longitude": 112.17881465821602,
			"name": "鄂州园"
		},
		{
			"id": 432,
			"latitude": 31.014171885071803,
			"longitude": 112.17881265821602,
			"name": "黄石园"
		},
		{
			"id": 433,
			"latitude": 31.014620885071803,
			"longitude": 112.17867265821602,
			"name": "十堰园"
		},
		{
			"id": 434,
			"latitude": 31.014727885071804,
			"longitude": 112.17809465821603,
			"name": "恩施园"
		},
		{
			"id": 435,
			"latitude": 31.016300885071803,
			"longitude": 112.17806565821603,
			"name": "孝感园"
		},
		{
			"id": 436,
			"latitude": 31.016922885071804,
			"longitude": 112.17844965821603,
			"name": "咸宁园"
		},
		{
			"id": 437,
			"latitude": 31.017813885071803,
			"longitude": 112.17386965821603,
			"name": "天门园"
		},
		{
			"id": 438,
			"latitude": 31.017069885071803,
			"longitude": 112.17308565821603,
			"name": "仙桃园"
		},
		{
			"id": 439,
			"latitude": 31.016304885071803,
			"longitude": 112.17299365821603,
			"name": "潜江园"
		},
		{
			"id": 440,
			"latitude": 31.008200885071804,
			"longitude": 112.17712465821603,
			"name": "漳河新区园"
		},
		{
			"id": 441,
			"latitude": 31.019657885071803,
			"longitude": 112.17672565821603,
			"name": "东宝园"
		},
		{
			"id": 442,
			"latitude": 31.017607885071804,
			"longitude": 112.17977965821603,
			"name": "高新掇刀园"
		},
		{
			"id": 443,
			"latitude": 31.017133885071803,
			"longitude": 112.18031065821602,
			"name": "屈家岭展园"
		},
		{
			"id": 444,
			"latitude": 31.016825885071804,
			"longitude": 112.18054365821602,
			"name": "沙洋园"
		},
		{
			"id": 445,
			"latitude": 31.016015885071804,
			"longitude": 112.18041865821602,
			"name": "钟祥园"
		},
		{
			"id": 446,
			"latitude": 31.015074885071803,
			"longitude": 112.18036365821602,
			"name": "京山园"
		},
		{
			"id": 447,
			"latitude": 31.007510885071803,
			"longitude": 112.17448065821603,
			"name": "精河园"
		},
		{
			"id": 448,
			"latitude": 31.008622885071803,
			"longitude": 112.17430765821603,
			"name": "台州园"
		},
		{
			"id": 449,
			"latitude": 31.008061885071803,
			"longitude": 112.17520165821603,
			"name": "浦项园"
		},
		{
			"id": 450,
			"latitude": 31.005115885071803,
			"longitude": 112.17723065821603,
			"name": "龙泉中学园"
		},
		{
			"id": 451,
			"latitude": 31.005545885071803,
			"longitude": 112.17769765821603,
			"name": "华农园"
		},
		{
			"id": 452,
			"latitude": 31.005399885071804,
			"longitude": 112.17818165821603,
			"name": "荆楚理工园"
		},
		{
			"id": 453,
			"latitude": 31.018052885071803,
			"longitude": 112.17381965821603,
			"name": "棕地修复园"
		}
	]
}, {
	type: 'shop',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/shop.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			id: 501,
			longitude: 112.17483650183294,
			latitude: 31.015508305884456,
			name: '商店'
		},
		{
			id: 502,
			longitude: 112.17418574144244,
			latitude: 31.014975935524113,
			name: '商店'
		}, {
			id: 503,
			longitude: 112.180688478084,
			latitude: 31.011367449857644,
			name: '商店'
		}, {
			id: 504,
			longitude: 112.18071797526875,
			latitude: 31.004806906174583,
			name: '商店'
		},
	]
}, {
	type: 'police',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/police.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
		id: 601,
		longitude: 112.18054306909119,
		latitude: 31.012457417297245,
		name: '警务室'
	}]
}, {
	type: 'hospital',
	iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/hospital.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
		id: 701,
		longitude: 112.18003803709314,
		latitude: 31.011659660809112,
		name: '医务室'
	}]
}]